/* eslint-disable */
import settings from "../../../configs/settings";
import { Autocomplete, Box, Button, Paper, TextField, Typography, Fab, Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { isNumeric } from "../../../project/utils/utils";
import CobranzaContext from "../../../project/contexts/CobranzaContext";
import { getObrasSociales } from "../../../project/services/ObraSocialService";
import { getObraSocialPlanes } from "../../../project/services/ObraSocialPlanService";
import { getTiposDocumentos } from "../../../project/services/TipoDocumentoService";


import { isPositiveInteger } from "../../../project/utils/utils";
import { getClienteByDocument } from "../../../project/services/ClienteService";
//
// ################################################################################
//
const CobroObraSocial = () => {
  const [valueACObraSocial, setValueACObraSocial] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACObraSocial, setInputValueACObraSocial] = useState("");

  const [valueACObraSocialPlan, setValueACObraSocialPlan] = useState({
    id: "",
    descripcion_obra_social_plan: "",
    id_obra_social: "",
  });
  const [inputValueACObraSocialPlan, setInputValueACObraSocialPlan] =
    useState("");

  const [valueACTipoDocumento, setValueACTipoDocumento] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACTipoDocumento, setInputValueACTipoDocumento] =
    useState("");

  const [isDoingSomething, setIsDoingSomething] = useState(false);

  const {
    setMessage,
    setShowMessage,
    handleChangeMedioDeCobro,
    limpiaMedioDeCobro,
    medioDeCobroAction,
    medioDeCobro,
    setMedioDeCobro,
    agregaMedioDeCobro,
    restoACobrar,
  } = useContext(CobranzaContext);

  const [obrasSociales, setObrasSociales] = useState([]);
  const [obraSocialPlanes, setObraSocialPlanes] = useState([]);
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [obraSocialPlanesTmp, setObraSocialPlanesTmp] = useState([]);

  const {
    idObraSocial,
    descripcionObraSocial,
    idObraSocialPlan,
    descripcionObraSocialPlan,
    remitoObraSocial,
    idTipoDocumento,
    descripcionTipoDocumento,
    numeroDocumentoClienteObraSocial,
    nombreClienteObraSocial,
    apellidoClienteObraSocial,
    numeroBeneficiarioClienteObraSocial,
    importe,
  } = medioDeCobro;
  const _importeAnterior = medioDeCobro.importe;
  //
  // ################################################################################
  //
  useEffect(() => {
    loadObrasSociales();
    loadObraSocialPlanes();
    loadTiposDocumentos();
    setValueACObraSocial({
      id: idObraSocial,
      descripcion: descripcionObraSocial,
    });

    setValueACObraSocialPlan({
      id: idObraSocialPlan,
      descripcion_obra_social_plan: descripcionObraSocialPlan,
      id_obra_social: idObraSocial,
    });

    setValueACTipoDocumento({
      id: idTipoDocumento,
      descripcion: descripcionTipoDocumento,
    });
  }, []);
  //
  // ################################################################################
  //
  const loadObrasSociales = async () => {
    const response = await getObrasSociales();
    if (response.ok) {
      setObrasSociales(response.data.data);
    } else {
      setObrasSociales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadObraSocialPlanes = async () => {
    const response = await getObraSocialPlanes();
    if (response.ok) {
      setObraSocialPlanes(response.data.data);
    } else {
      setObraSocialPlanes([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTiposDocumentos = async () => {
    const response = await getTiposDocumentos();
    if (response.ok) {
      setTiposDocumentos(response.data.data);
    } else {
      setTiposDocumentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACObraSocial.id !== valueACObraSocialPlan.id_obra_social) {
      setValueACObraSocialPlan({
        id: "",
        descripcion_obra_social_plan: "",
        id_obra_social: "",
      });
      setObraSocialPlanesTmp([]);
    }

    if (valueACObraSocial) {
      // si se selecciona una obra social, filtro los planes de la obra social seleccionada

      setObraSocialPlanesTmp(
        obraSocialPlanes.filter((item) => {
          return item.id_obra_social === valueACObraSocial.id ? item : null;
        })
      );
    }
  }, [valueACObraSocial]);
  //
  // ################################################################################
  //
  useEffect(() => {
    let _plan = obraSocialPlanes.find((item) => item.id === valueACObraSocialPlan.id);
    let _importe = _plan ? _plan.importe_obra_social_plan : 0;

    setMedioDeCobro({
      ...medioDeCobro,
      idObraSocial: valueACObraSocial.id,
      descripcionObraSocial: valueACObraSocial.descripcion,
      idObraSocialPlan: valueACObraSocialPlan.id,
      descripcionObraSocialPlan: valueACObraSocialPlan.descripcion_obra_social_plan,
      importe: _importe,
    });
  }, [valueACObraSocialPlan]);
  //
  // ################################################################################
  //
  useEffect(() => {
    setMedioDeCobro({
      ...medioDeCobro,
      idTipoDocumento: valueACTipoDocumento.id,
      descripcionTipoDocumento: valueACTipoDocumento.descripcion,
    });
  }, [valueACTipoDocumento]);
  //
  // ################################################################################
  //
  const cancelaCobro = () => {
    limpiaMedioDeCobro();
    // setExpandedAccordionMediosDeCobro(false);
  };
  //
  // ################################################################################
  //
  const handleBlurDocumento = () => {
    if (
      !isPositiveInteger(numeroDocumentoClienteObraSocial) ||
      numeroDocumentoClienteObraSocial.length < 7
    ) {
      setMessage({
        severity: "error",
        messageText: "El documento del Cliente debe ser un número de 7 o más dígitos",
      });
      setShowMessage(true);
      return;
    }

    const loadCliente = async () => {
      let _params = {
        tipoDocumento: idTipoDocumento,
        numeroDocumento: numeroDocumentoClienteObraSocial,
      };

      setIsDoingSomething(true);
      const response = await getClienteByDocument(_params);
      setIsDoingSomething(false);

      if (response.ok) {
        if (response.exist) {
          // si existe el cliente

          setMedioDeCobro({
            ...medioDeCobro,
            nombreClienteObraSocial: response.data.data.nombre,
            apellidoClienteObraSocial: response.data.data.apellido,
          });
        } else {
          // si no existe el cliente
          setMedioDeCobro({
            ...medioDeCobro,
            nombreClienteObraSocial: "",
            apellidoClienteObraSocial: "",
          });
        }
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };
    loadCliente();
  };
  //
  // ################################################################################
  //
  const actualizaCobro = () => {

    if (inputValueACObraSocial === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar una Obra Social",
      });
      setShowMessage(true);
      return;
    }

    if (inputValueACObraSocialPlan === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar un Plan de la Obra Social",
      });
      setShowMessage(true);
      return;
    }

    if (typeof importe === "string") {
      if (!isNumeric(importe)) {
        setMessage({
          severity: "error",
          messageText: "No es válido el importe del Plan de la Obra Social",
        });
        setShowMessage(true);
        return;
      }
    }

    if (+importe <= 0) {
      setMessage({
        severity: "error",
        messageText: "No es válido el importe del Plan de la Obra Social",
      });
      setShowMessage(true);
      return;
    }

    if (inputValueACTipoDocumento === "") {
      setMessage({
        severity: "error",
        messageText: "Debes seleccionar el tipo de documento del Cliente",
      });
      setShowMessage(true);
      return;
    }

    if (numeroDocumentoClienteObraSocial === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de documento del Cliente",
      });
      setShowMessage(true);
      return;
    }

    if (nombreClienteObraSocial === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el nombre del Cliente",
      });
      setShowMessage(true);
      return;
    }

    if (apellidoClienteObraSocial === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el apellido del Cliente",
      });
      setShowMessage(true);
      return;
    }

    if (numeroBeneficiarioClienteObraSocial === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de beneficiario del Cliente en la Obra Social",
      });
      setShowMessage(true);
      return;
    }

    if (remitoObraSocial === "") {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el número de remito/autorización de la Obra Social",
      });
      setShowMessage(true);
      return;
    }

    if (
      +importe >
      (medioDeCobroAction.cu === "new" ? restoACobrar : restoACobrar + _importeAnterior)
    ) {
      setMessage({
        severity: "error",
        messageText: "El importe cobrado debe ser menor o igual al resto a cobrar",
      });
      setShowMessage(true);
      return;
    }

    // si no hay errores agrego el medio de cobro a la tabla de medios de cobro

    agregaMedioDeCobro("obra-social");
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={2} sx={{ mt: 1, p: 2 }}>
        <Typography component={"span"} variant={"body1"}>
          Obra Social
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Autocomplete
            size="small"
            value={valueACObraSocial}
            onChange={(event, newValue) => {
              setValueACObraSocial(newValue);
            }}
            inputValue={inputValueACObraSocial}
            onInputChange={(event, newInputValue) => {
              setInputValueACObraSocial(newInputValue);
            }}
            options={obrasSociales}
            renderInput={(params) => <TextField {...params} label="Obras Sociales" />}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option.descripcion ?? option}
            disableClearable={true}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <Autocomplete
            size="small"
            value={valueACObraSocialPlan}
            onChange={(event, newValue) => {
              setValueACObraSocialPlan(newValue);
            }}
            inputValue={inputValueACObraSocialPlan}
            onInputChange={(event, newInputValue) => {
              setInputValueACObraSocialPlan(newInputValue);
            }}
            options={obraSocialPlanesTmp}
            renderInput={(params) => <TextField {...params} label="Planes de Obra Social" />}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option.descripcion_obra_social_plan ?? option}
            disableClearable={true}
          />
        </Box>
        <Box sx={{ mt: 1 }}>
          <TextField
            sx={{ width: "50%" }}
            label="Importe"
            variant="outlined"
            size="small"
            name="importe"
            value={importe.toLocaleString(
              settings.numericLocales.language,
              settings.numericLocales.options
            )}
            onChange={handleChangeMedioDeCobro}
            inputProps={{
              style: { textAlign: "right" },
            }}
            disabled={true}
          />
        </Box>

        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box sx={{ mt: 1 }}>
              <Autocomplete
                size="small"
                value={valueACTipoDocumento}
                onChange={(event, newValue) => {
                  setValueACTipoDocumento(newValue);
                }}
                inputValue={inputValueACTipoDocumento}
                onInputChange={(event, newInputValue) => {
                  setInputValueACTipoDocumento(newInputValue);
                }}
                options={tiposDocumentos}
                renderInput={(params) => <TextField {...params} label="Tipos de Documentos" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                getOptionLabel={(option) => option.descripcion ?? option}
                disableClearable={true}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box sx={{ mt: 1 }}>
              <TextField
                sx={{ width: "100%" }}
                label="Número de Documento"
                variant="outlined"
                size="small"
                name="numeroDocumentoClienteObraSocial"
                value={numeroDocumentoClienteObraSocial}
                onChange={handleChangeMedioDeCobro}
                onBlur={handleBlurDocumento}
                inputProps={{
                  autoComplete: "off",
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <TextField
                sx={{ width: "100%" }}
                label="Nombre"
                variant="outlined"
                size="small"
                name="nombreClienteObraSocial"
                value={nombreClienteObraSocial}
                onChange={handleChangeMedioDeCobro}
                inputProps={{
                  autoComplete: "off",
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <TextField
                sx={{ width: "100%" }}
                label="Apellido"
                variant="outlined"
                size="small"
                name="apellidoClienteObraSocial"
                value={apellidoClienteObraSocial}
                onChange={handleChangeMedioDeCobro}
                inputProps={{
                  autoComplete: "off",
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <TextField
                sx={{ width: "100%" }}
                label="Número de Beneficiario"
                variant="outlined"
                size="small"
                name="numeroBeneficiarioClienteObraSocial"
                value={numeroBeneficiarioClienteObraSocial}
                onChange={handleChangeMedioDeCobro}
                inputProps={{
                  autoComplete: "off",
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box>
              <TextField
                sx={{ width: "100%" }}
                label="Número de Remito/Autorización"
                variant="outlined"
                size="small"
                name="remitoObraSocial"
                value={remitoObraSocial}
                onChange={handleChangeMedioDeCobro}
                inputProps={{
                  autoComplete: "off",
                }}
              />
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ p: 1 }}>
          <Fab
            sx={{ mr: 1 }}
            color="primary"
            aria-label="add"
            size="small"
            onClick={actualizaCobro}
          >
            <CheckOutlinedIcon />
          </Fab>

          <Fab sx={{ mr: 1 }} color="outlined" aria-label="add" size="small" onClick={cancelaCobro}>
            <CloseOutlinedIcon />
          </Fab>
        </Box>
      </Paper>
    </>
  );
};

export default CobroObraSocial;
